import React, { HTMLAttributes, ReactElement } from 'react';
import MultiCarousel, { ResponsiveType } from 'react-multi-carousel';
import classNames from 'classnames';

import './carousel.scss';

export interface CarouselInterface {
    dots?: boolean;
    arrows?: boolean;
    infinite?: boolean;
    responsive?: ResponsiveType;
    autoPlay?: boolean;
    autoPlaySpeed?: number;
    customButtonGroup?: React.ReactElement | null;
    renderButtonGroupOutside?: boolean;
    customLeftArrow?: React.ReactElement | null;
    customRightArrow?: React.ReactElement | null;
    partialVisible?: boolean;
}

interface SliderProps extends CarouselInterface, HTMLAttributes<HTMLElement> {
}

const Carousel: React.FC<SliderProps> = (
    {
        dots = false,
        arrows = false,
        infinite = true,
        children,
        className,
        responsive,
        autoPlay = false,
        autoPlaySpeed = 5000,
        customButtonGroup = null,
        renderButtonGroupOutside = false,
        customLeftArrow = null,
        customRightArrow = null,
        partialVisible = false
    }
): ReactElement => {
    const carouselClasses = classNames(className);
    const responsiveData = responsive || {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 5
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 5
        }
    };

    return (
        <MultiCarousel
            className={carouselClasses}
            responsive={responsiveData}
            showDots={dots}
            arrows={arrows}
            infinite={infinite}
            autoPlay={autoPlay}
            autoPlaySpeed={autoPlaySpeed}
            ssr={true}
            customButtonGroup={customButtonGroup}
            renderButtonGroupOutside={renderButtonGroupOutside}
            customLeftArrow={customLeftArrow}
            customRightArrow={customRightArrow}
            partialVisible={partialVisible}
        >
            {children}
        </MultiCarousel>
    );
};

export default Carousel;
